/** Build the display URL without dropping filters or repeated query values. */
export function queryPath(pathname: string, query: Record<string, string | string[] | undefined>): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    for (const item of Array.isArray(value) ? value : value === undefined ? [] : [value]) params.append(key, item);
  }
  const search = params.toString();
  return search ? `${pathname}?${search}` : pathname;
}
